var PersonalMessagingController = function () {};

PersonalMessagingController.$inject = [];
export default PersonalMessagingController;
